module.exports = __webpack_public_path__ + "static/media/DancingAtTheInn.8f46da0b.mp3";